/**
 * The one piece of the event envelope only the client can own: `session_id`
 * (product doc Section 4 — "client-generated, tab-scoped"). Split out of
 * analytics.js into its own module so api.js can read it without a
 * api.js <-> analytics.js import cycle (analytics.js itself calls back into
 * api.js's trackEvent to emit session.start/heartbeat/end).
 */
const SESSION_ID_KEY = 'mira_session_id';

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`);
      sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    // Private-mode/storage-blocked fallback: a per-load id is still better
    // than no session_id at all, just no longer stable across a reload.
    return `volatile-${Date.now()}`;
  }
}
